import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  TabContent,
  TabPane,
  Progress,
  NavLink,
  NavItem,
  Button,
  CardTitle,
  FormFeedback,
  FormText
} from "reactstrap";
import classnames from "classnames";
import { Link, Navigate } from "react-router-dom";
import Async from 'react-select/async';
import { connect } from "react-redux";
import { clearUpdateDeviceError, updateDevice } from "../../store/deviceDetails/actions";
import { getAssignableProductsForAsyncSelect } from "../../store/products/actions";
import Message from "../../CommonData/Data/Message";
import { clearForm, updateForm } from "../../store/form/actions";
import VWLoading from "../../components/vwLoading/vwLoading";
import { AMC_STATUS_OPTIONS } from "../../store/device/actionTypes";

const FormWizard = (props) => {
  const { deviceDetails, errorMessage, form, isPending } = props;
  const [activeTabwiz, setoggleTabwiz] = useState(1);
  const [passedStepswiz, setpassedStepswiz] = useState([1]);
  const [device, setDevice] = useState("");
  const [selected_product, setSelectedProduct] = useState("");

  useEffect(() => {
    const { updateForm, clearForm, clearUpdateDeviceError } = props || {};

    if (deviceDetails) {
      const selected_product = {
        label: deviceDetails.name,
        value: deviceDetails.name,
      };
      setDevice({ ...deviceDetails, SubscriptionValidate: deviceDetails.subcriptionValidity });
      setSelectedProduct(selected_product);
      updateForm({
        formAddDevice: {
          formAddDevice1: {
            selected_product: selected_product,
            hardwareVersion: deviceDetails.hardwareVersion,
            firmwareVersion: deviceDetails.firmwareVersion,
            sensorType: deviceDetails.sensorType,
            id: deviceDetails.id,
            modelNo: deviceDetails.modelNo
          },
          formAddDevice2: {
            description: deviceDetails.description,
            isActive: deviceDetails.isActive,
            SubscriptionValidate: deviceDetails.subcriptionValidity,
            // ...deviceDetails
          },
          formAddDevice3: {
            amcStartDate: deviceDetails.amcStartDate,
            amcEndDate: deviceDetails.amcEndDate,
            amcStatus: deviceDetails.amcStatus,
            // ...deviceDetails
          },
          errors1: {},
          errors2: {},
          errors3: {},
        }
      })
    }

    clearUpdateDeviceError();
    return () => {
      clearForm();
      clearUpdateDeviceError();
    }
  }, [deviceDetails]);

  const handleInputChange1 = (event) => {
    const { name, value } = event.target;
    setDevice({ ...device, [name]: value });
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice1: {
          ...form.formAddDevice.formAddDevice1,
          [name]: value
        },
        errors1: {
          ...form && form.formAddDevice.errors1,
          [name]: null,
        }
      }
    });
  }

  const handleLoadProducts = (inputValue, callback) => {
    props.getAssignableProductsForAsyncSelect(inputValue, callback);
  };

  const handleAddProductChange = (value) => {
    setDevice({ ...device, selected_product: value });
    setSelectedProduct(value);
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice1: {
          ...form.formAddDevice.formAddDevice1,
          selected_product: value
        },
        errors1: {
          ...form && form.formAddDevice.errors1,
          selected_product: null,
        }
      }
    });

  };

  const handleInputChange2 = (event) => {
    const { name, value } = event.target;
    setDevice({ ...device, [name]: value });
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice2: {
          ...form.formAddDevice.formAddDevice2,
          [name]: value === "" ? null : value
        },
        errors2: {
          ...form && form.formAddDevice.errors2,
          [name]: null,
        }
      }
    });
  }
  const handleInputChange3 = (event) => {
    const { name, value } = event.target;
    setDevice({ ...device, [name]: value });
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice3: {
          ...form.formAddDevice.formAddDevice3,
          [name]: value
        },
        errors3: {
          ...form && form.formAddDevice.errors3,
          [name]: null,
        }
      }
    });
  }
  const handleNotificationStatusChange = () => {
    setDevice({ ...device, isActive: !device.isActive })
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice2: {
          ...form.formAddDevice.formAddDevice2,
          isActive: !device.isActive
        },
        errors2: {
          ...form && form.formAddDevice.errors2,
          isActive: null,
        }
      }
    });
  };

  //---------------------VALIDATION & PAGE NAVIGATION-----------------------------------------------------------
  const toggleTabwiz = (tab) => {
    const { formAddDevice } = form || {};
    const { formAddDevice1, formAddDevice2, formAddDevice3 } = formAddDevice || {};
    const { selected_product, hardwareVersion, firmwareVersion, sensorType, modelNo } = formAddDevice1 || {};
    const { SubscriptionValidate } = formAddDevice2 || {};
    const { amcStartDate, amcEndDate, amcStatus, } = formAddDevice3 || {};

    let errors = {};
    const currentErrors1 = {};
    const currentErrors2 = {};
    const currentErrors3 = {};

    //---------------------TAB-1-----------------------------------------------------------
    if (activeTabwiz === 1) {
      if (!selected_product) {
        currentErrors1.selected_product = "Product name is required"
      }
      if (!modelNo) {
        currentErrors1.modelNo = "Model number is required"
      }
      if (!hardwareVersion) {
        currentErrors1.hardwareVersion = "Hardware version is required"
      }
      if (!firmwareVersion) {
        currentErrors1.firmwareVersion = "Firmware version is required"
      }
      if (!sensorType) {
        currentErrors1.sensorType = "Lot number is required"
      }

      props.updateForm({
        formAddDevice: {
          ...formAddDevice,
          formAddDevice1: {
            ...form.formAddDevice.formAddDevice1,
          },
          errors1: currentErrors1,
        }
      })

      errors = currentErrors1;
    }

    //---------------------TAB-2-----------------------------------------------------------
    if (activeTabwiz === 2) {
      if (!SubscriptionValidate) {
        currentErrors2.SubscriptionValidate = "Subscription validation is required"
      }

      props.updateForm({
        formAddDevice: {
          ...formAddDevice,
          formAddDevice2: {
            ...form.formAddDevice.formAddDevice2,
          },
          errors2: currentErrors2,
        }
      })

      errors = currentErrors2;
    }

    //---------------------TAB-3-----------------------------------------------------------
    if (activeTabwiz === 3) {
      if (!amcStartDate) {
        currentErrors3.amcStartDate = "AMC start date name is required"
      }
      if (!amcEndDate) {
        currentErrors3.amcEndDate = "AMC end date is required"
      }
      if (!amcStatus) {
        currentErrors3.amcStatus = "AMC status is required"
      }

      props.updateForm({
        formAddDevice: {
          ...formAddDevice,
          formAddDevice3: {
            ...form.formAddDevice.formAddDevice3,
          },
          errors3: currentErrors3,
        }
      })

      errors = currentErrors3;
    }

    if (Object.keys(errors).length === 0) {
      if (activeTabwiz !== tab) {
        var modifiedSteps = [...passedStepswiz, tab];
        if (tab >= 1 && tab <= 4) {
          setoggleTabwiz(tab);
          setpassedStepswiz(modifiedSteps);
        }
      }
    }
    else {
      if (activeTabwiz > tab) {
        var modifiedSteps = [...passedStepswiz, tab];
        if (tab >= 1 && tab <= 4) {
          setoggleTabwiz(tab);
          setpassedStepswiz(modifiedSteps);
        }
      }
    }
  }


  //---------------------DEVICE CREATE FORM SUBMISSION----------------------------------------------------
  const handleUpdateDevice = () => {
    const data = {
      ...form.formAddDevice.formAddDevice1,
      ...form.formAddDevice.formAddDevice2,
      ...form.formAddDevice.formAddDevice3,
    }
    props.updateDevice(data);
  };

  return props.isSuccess ? (<Navigate to={`/devicelist/details/${device.id}`} />) : (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardTitle className='d-flex justify-content-between align-items-center m-2 border-bottom border-dark mb-0'>
                  <h5 className="fw-bold">EDIT DEVICE</h5>
                  <Link to={`/devicelist/details/${device.id}`} className="text-dark">
                    <i className="mdi mdi-close fs-2"></i>
                  </Link>
                </CardTitle>
                <CardBody>
                  {errorMessage && (
                    <Message
                      type="danger"
                      defaultMessage={errorMessage}
                      baseClassName="alert"
                    />
                  )}
                  <div id="progrss-wizard" className="twitter-bs-wizard">
                    <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                      <NavItem className={classnames({ active: activeTabwiz === 1 })}>
                        <NavLink
                          className={(classnames({ active: activeTabwiz === 1 }))}
                          onClick={() => toggleTabwiz(1)}
                        >
                          <span className="step-number">01</span>
                          <span className="step-title" style={{ paddingLeft: "10px" }}>Product Details</span>
                        </NavLink>
                      </NavItem>
                      <NavItem className={classnames({ active: activeTabwiz === 2 })}>
                        <NavLink
                          className={(classnames({ active: activeTabwiz === 2 }))}
                          onClick={() => toggleTabwiz(2)}
                        >
                          <span className="step-number">02</span>
                          <span className="step-title" style={{ paddingLeft: "10px" }}>Other Details</span>
                        </NavLink>
                      </NavItem>
                      <NavItem className={classnames({ active: activeTabwiz === 3 })}>
                        <NavLink
                          className={(classnames({ active: activeTabwiz === 3 }))}
                          onClick={() => toggleTabwiz(3)}
                        >
                          <span className="step-number">03</span>
                          <span className="step-title" style={{ paddingLeft: "10px" }}>AMC Details</span>
                        </NavLink>
                      </NavItem>
                      <NavItem className={classnames({ active: activeTabwiz === 4 })}>
                        <NavLink
                          className={(classnames({ active: activeTabwiz === 4 }))}
                          onClick={() => toggleTabwiz(4)}
                        >
                          <span className="step-number">04</span>
                          <span className="step-title" style={{ paddingLeft: "10px" }}>Confirm details</span>
                        </NavLink>
                      </NavItem>
                    </ul>
                    <div id="bar" className="mt-4">
                      <div className="mb-4">
                        <Progress
                          value={40 * activeTabwiz}
                          color="success"
                          animated
                        />
                      </div>
                    </div>
                    <TabContent activeTab={activeTabwiz} className="twitter-bs-wizard-tab-content">
                      <TabPane tabId={1}>
                        <Form>
                          <Row>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-firstname-input12">
                                  Product Name
                                </Label><span className="text-danger">*</span>
                                <Async
                                  autoFocus
                                  openMenuOnFocus={true}
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: (form && form.formAddDevice
                                        && form.formAddDevice.errors1 &&
                                        form.formAddDevice.errors1.selected_product) ? 'red' : ""
                                    })
                                  }}
                                  name="selected_product"
                                  placeholder="Select Product"
                                  defaultOptions
                                  menuPortalTarget={document.body}
                                  loadOptions={handleLoadProducts}
                                  onChange={handleAddProductChange}
                                  value={selected_product}
                                />
                                {(form && form.formAddDevice
                                  && form.formAddDevice.errors1 &&
                                  form.formAddDevice.errors1.selected_product) &&
                                  <FormText sx={{ marginLeft: "10px" }}>
                                    <div className="text-danger">
                                      {form && form.formAddDevice
                                        && form.formAddDevice.errors1 &&
                                        form.formAddDevice.errors1.selected_product}
                                    </div>
                                  </FormText>
                                }
                              </FormGroup>
                            </Col>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-lastname-input22">
                                  Model Number
                                </Label><span className="text-danger">*</span>
                                <Input
                                  // id="basicpill-lastname-input22"
                                  className="form-control"
                                  type="text"
                                  name="modelNo"
                                  placeholder="Enter device model number"
                                  onChange={handleInputChange1}
                                  value={device.modelNo}
                                  invalid={form && form.formAddDevice
                                    && form.formAddDevice.errors1 &&
                                    form.formAddDevice.errors1.modelNo}
                                />
                                <FormFeedback>
                                  {form && form.formAddDevice
                                    && form.formAddDevice.errors1 &&
                                    form.formAddDevice.errors1.modelNo}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-lastname-input22">
                                  Hardware Version
                                </Label><span className="text-danger">*</span>
                                <Input
                                  type="text"
                                  name="hardwareVersion"
                                  className="form-control"
                                  id="basicpill-lastname-input22"
                                  placeholder="Enter your hardware version"
                                  onChange={handleInputChange1}
                                  value={device.hardwareVersion}
                                  invalid={form && form.formAddDevice
                                    && form.formAddDevice.errors1 &&
                                    form.formAddDevice.errors1.hardwareVersion}
                                />
                                <FormFeedback>
                                  {form && form.formAddDevice
                                    && form.formAddDevice.errors1 &&
                                    form.formAddDevice.errors1.hardwareVersion}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-email-input42">
                                  Firmware Version
                                </Label><span className="text-danger">*</span>
                                <Input
                                  name="firmwareVersion"
                                  type="text"
                                  className="form-control"
                                  id="basicpill-email-input42"
                                  placeholder="Enter your firmware version"
                                  onChange={handleInputChange1}
                                  value={device.firmwareVersion}
                                  invalid={form && form.formAddDevice
                                    && form.formAddDevice.errors1 &&
                                    form.formAddDevice.errors1.firmwareVersion}
                                />
                                <FormFeedback>
                                  {form && form.formAddDevice
                                    && form.formAddDevice.errors1 &&
                                    form.formAddDevice.errors1.firmwareVersion}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-address-input12">
                                  Lot Number
                                </Label><span className="text-danger">*</span>
                                <Input
                                  id="basicpill-address-input12"
                                  className="form-control"
                                  name="sensorType"
                                  placeholder="Enter your lot number"
                                  onChange={handleInputChange1}
                                  value={device.sensorType}
                                  invalid={form && form.formAddDevice
                                    && form.formAddDevice.errors1 &&
                                    form.formAddDevice.errors1.sensorType}
                                />
                                <FormFeedback>
                                  {form && form.formAddDevice
                                    && form.formAddDevice.errors1 &&
                                    form.formAddDevice.errors1.sensorType}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          </Row>
                        </Form>
                      </TabPane>
                      <TabPane tabId={2}>
                        <div>
                          <Form>
                            <Row>
                              <Col lg="6">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="basicpill-vatno-input62">
                                    Description
                                  </Label>
                                  <Input
                                    type="text"
                                    name="description"
                                    className="form-control"
                                    id="basicpill-vatno-input62"
                                    placeholder="Enter your description"
                                    onChange={handleInputChange2}
                                    value={device.description}
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="basicpill-vatno-input62">
                                    Subscription Validity
                                  </Label><span className="text-danger">*</span>
                                  <Input
                                    type="date"
                                    name="SubscriptionValidate"
                                    className="form-control"
                                    id="basicpill-vatno-input62"
                                    placeholder="Enter device subscription validity"
                                    onChange={handleInputChange2}
                                    value={device.SubscriptionValidate && device.SubscriptionValidate.split('T')[0]}
                                    invalid={form && form.formAddDevice
                                      && form.formAddDevice.errors2 &&
                                      form.formAddDevice.errors2.SubscriptionValidate}
                                  />
                                  <FormFeedback>
                                    {form && form.formAddDevice
                                      && form.formAddDevice.errors2 &&
                                      form.formAddDevice.errors2.SubscriptionValidate}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <FormGroup className="mb-3">
                                  <Label>Device Status</Label>
                                  <p>You can active or inactive the device.</p>
                                  <ul className="form-unstyled-list form-status-list">
                                    <li
                                      onClick={handleNotificationStatusChange}
                                      className={`form-status-item ${!device.isActive ? "active" : ""}`}
                                    >
                                      Disable
                                    </li>
                                    <li
                                      onClick={handleNotificationStatusChange}
                                      className={`form-status-item ${device.isActive ? "active" : ""}`}
                                    >
                                      Enable
                                    </li>
                                  </ul>
                                  <br /><br />
                                </FormGroup>
                              </Col>
                            </Row>
                          </Form>
                        </div>
                      </TabPane>
                      <TabPane tabId={3}>
                        <Form>
                          <Row>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-vatno-input62">
                                  AMC Start Date
                                </Label><span className="text-danger">*</span>
                                <Input
                                  type="date"
                                  name="amcStartDate"
                                  className="form-control"
                                  id="basicpill-vatno-input62"
                                  placeholder="Enter device AMC start date"
                                  onChange={handleInputChange3}
                                  value={device.amcStartDate && device.amcStartDate.split('T')[0]}
                                  invalid={form && form.formAddDevice
                                    && form.formAddDevice.errors3 &&
                                    form.formAddDevice.errors3.amcStartDate}
                                />
                                <FormFeedback>
                                  {form && form.formAddDevice
                                    && form.formAddDevice.errors3 &&
                                    form.formAddDevice.errors3.amcStartDate}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-vatno-input62">
                                  AMC End Date
                                </Label><span className="text-danger">*</span>
                                <Input
                                  type="date"
                                  name="amcEndDate"
                                  className="form-control"
                                  id="basicpill-vatno-input62"
                                  placeholder="Enter device AMC end date"
                                  onChange={handleInputChange3}
                                  value={device.amcEndDate && device.amcEndDate.split('T')[0]}
                                  invalid={form && form.formAddDevice
                                    && form.formAddDevice.errors3 &&
                                    form.formAddDevice.errors3.amcEndDate}
                                />
                                <FormFeedback>
                                  {form && form.formAddDevice
                                    && form.formAddDevice.errors3 &&
                                    form.formAddDevice.errors3.amcEndDate}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-vatno-input62">
                                  AMC Status
                                </Label><span className="text-danger">*</span>
                                <Input
                                  type="select"
                                  name="amcStatus"
                                  className="form-control"
                                  id="basicpill-vatno-input62"
                                  placeholder="Enter device AMC status"
                                  onChange={handleInputChange3}
                                  value={device.amcStatus}
                                  invalid={form && form.formAddDevice
                                    && form.formAddDevice.errors3 &&
                                    form.formAddDevice.errors3.amcStatus}
                                >
                                  <option value="">Select</option>
                                  {AMC_STATUS_OPTIONS && AMC_STATUS_OPTIONS.map((option) => (
                                    <option key={option.value} value={option.value}>
                                      {option.label}
                                    </option>
                                  ))}
                                </Input>
                                <FormFeedback>
                                  {form && form.formAddDevice && form.formAddDevice.errors3 && form.formAddDevice.errors3.amcStatus}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          </Row>
                        </Form>
                      </TabPane>
                      <TabPane tabId={4}>
                        <div className="row justify-content-center">
                          <Col lg="12">
                            {isPending ? <VWLoading /> :
                              <div className="text-center">
                                <div className="mb-4">
                                  <i className="mdi mdi-check-circle-outline text-success display-4" />
                                </div>
                                <div>
                                  <h5>Confirm Details</h5>
                                  <p className="text-muted">
                                    The device details are going to update. Are you sure to update?
                                  </p>
                                  <Button color="success" onClick={handleUpdateDevice}>Submit</Button>
                                  <Link className="btn btn-danger ms-4" to={`/devicelist/details/${device.id}`}>
                                    Cancel
                                  </Link></div>
                              </div>}
                          </Col>
                        </div>
                      </TabPane>
                    </TabContent>
                    <ul className="pager wizard twitter-bs-wizard-pager-link">
                      <li className={activeTabwiz === 1 ? "previous disabled me-2" : "previous me-2"}>
                        {activeTabwiz !== 1 && <Button
                          color='primary'
                          onClick={() => toggleTabwiz(activeTabwiz - 1)}
                          disabled={activeTabwiz === 1}>
                          Previous
                        </Button>
                        }
                      </li>
                      <li className={activeTabwiz === 4 ? "next disabled" : "next"}>
                        {activeTabwiz !== 4 && <Button
                          color='primary'
                          onClick={() => toggleTabwiz(activeTabwiz + 1)}
                          disabled={activeTabwiz === 4}>
                          Next
                        </Button>
                        }
                      </li>
                    </ul>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
};

const mapStateToProps = (state) => ({
  isPending: state.deviceDetails.isUpdateDevicePending,
  errorMessage: state.deviceDetails.updateDeviceErrorMessage,
  deviceDetails: state.deviceDetails.device,
  errorMessage: state.deviceDetails.errorMessage,
  isSuccess: state.deviceDetails.isSuccess,
  form: state.form.form,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (updateDevices) => dispatch(updateForm(updateDevices)),
  clearForm: () => dispatch(clearForm()),
  clearUpdateDeviceError: () => dispatch(clearUpdateDeviceError()),
  updateDevice: (device) => dispatch(updateDevice(device)),
  getAssignableProductsForAsyncSelect: (searchValue, callback) => dispatch(getAssignableProductsForAsyncSelect(searchValue, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormWizard);
